import React, { useEffect, useMemo, useState } from "react";
import { View } from "react-native";
import ThemeProvider from "@voltmoney/theme";
import { AspectRatioToken, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Image } from "../../../image/Image";
import { Typography } from "../../../typography/Typography";
import { Space } from "../../../space/Space";
import ProgressBarComponent from "../../../progressBar";
import { Icon } from "../../../icon/Icon";
import { Button } from "../../../button/Button";
const CgtcInProgressPage = ({ show = true, cancelAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [timer, setTimer] = useState(30);
    const [showCancel, setShowCancel] = useState(false);
    let timerInterval;
    const startTimer = () => {
        //Set
        timerInterval = setInterval(() => {
            setTimer(resendTimer => resendTimer - 1);
        }, 1000);
    };
    useEffect(() => {
        if (timer === 1) {
            setShowCancel(true);
            clearInterval(timerInterval);
            setTimer(30);
        }
    }, [timer]);
    useEffect(() => {
        startTimer();
    }, []);
    const renderImage = () => {
        return useMemo(() => (React.createElement(React.Fragment, null,
            React.createElement(Image, { width: 140, height: 140, size: ImageSizeTokens.Size_60, aspectRatio: AspectRatioToken.A1_1, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details_1.svg' }))), []);
    };
    return (React.createElement(View, { style: [
            styles.container,
            {
                width: '100%',
                padding: 24,
                backgroundColor: colorMapping[ColorTokens.White]
            }
        ] },
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                maxWidth: 382
            } },
            renderImage(),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(Typography, { label: 'Hold tight! We are currently generating your capital gains statement.', typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
            React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
            React.createElement(ProgressBarComponent, { height: 8, indeterminate: true }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Typography, { label: 'This could take up to ', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }),
                React.createElement(Typography, { label: '30 secs', typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            showCancel &&
                React.createElement(Button, { label: 'Cancel', sizeDLS: ButtonSizeDLS.LARGE, typeDLS: ButtonTypeDLS.TERTIARY, onPress: () => {
                        cancelAction &&
                            triggerAction(cancelAction);
                    } }),
            React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XXL }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(Typography, { label: '100% Safe & Secure', typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Secondary_100 })))));
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export default CgtcInProgressPage;
